import React from 'react';
import { Slider } from '@material-ui/core';
import { getAmountInMinutesFromRange } from '../../../../services/Slider/PartialSliderHelper';
import { getUserFormats } from '../../../../common-client2/src/services/ukgDateTime';
import moment from 'moment';
import './EmployeeScheduleIndicator.scss';

/**
 * Component to display employee scheduled shifts as visual indicators on the slider
 * These are read-only sliders that show where employee shifts fall within the request period
 * @param {Object} props
 * @param {Object} props.shift - The shift object with startDateTime and endDateTime
 * @param {Date} props.minStartDate - The minimum start date of the period
 * @param {Date} props.maxEndDate - The maximum end date of the period
 */
const EmployeeScheduleIndicator = ({ shift, minStartDate, maxEndDate }) => {
    // Convert to Date objects if needed
    const sliderStartDate = minStartDate;
    const sliderEndDate = maxEndDate;
    const maxMinuteInRange = getAmountInMinutesFromRange(minStartDate, maxEndDate);

    let shiftStart = new Date(shift.startDateTime);
    let shiftEnd = new Date(shift.endDateTime);

    const isShiftStartBeforeSliderStart = shiftStart < sliderStartDate;
    shiftStart = isShiftStartBeforeSliderStart ? sliderStartDate : shiftStart;

    const isShiftEndAfterSliderEnd = shiftEnd > sliderEndDate;
    shiftEnd = isShiftEndAfterSliderEnd ? sliderEndDate : shiftEnd;

    // Calculate shift position relative to period start (in minutes)
    const rawShiftStartMinutes = getAmountInMinutesFromRange(sliderStartDate, shiftStart);
    const rawShiftEndMinutes = getAmountInMinutesFromRange(sliderStartDate, shiftEnd);

    // Determine if user's time format uses meridiem (AM/PM)
    const userTimeFormat = getUserFormats().TimeFormat || '';
    const hasMeridiem = userTimeFormat.toLowerCase().includes('a');
    const timeFormat = hasMeridiem ? 'h:mm A' : 'HH:mm';

    // Create marks for the shift start and end times
    // Only show labels for times that are actually within the visible range
    const marks = [];
    if (!isShiftStartBeforeSliderStart) {
        marks.push({
            value: rawShiftStartMinutes,
            label: moment(shift.startDateTime).format(timeFormat),
        });
    }
    if (!isShiftEndAfterSliderEnd) {
        marks.push({
            value: rawShiftEndMinutes,
            label: moment(shift.endDateTime).format(timeFormat),
        });
    } 

    return (
        <div className="employee-schedule-indicator">
            <div className="employee-schedule-slider">
                <Slider
                    value={[rawShiftStartMinutes, rawShiftEndMinutes]}
                    max={maxMinuteInRange}
                    disabled={true}
                    marks={marks}
                />
            </div>
        </div>
    );
};

export default EmployeeScheduleIndicator;

